import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=e230074a"
import script from "./authManage.vue?vue&type=script&lang=js"
export * from "./authManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports